module.exports = __webpack_public_path__ + "img/disability-card.742378ae.png";